module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-lucas-difference"
  }, [_c('div', {
    staticClass: "tab-lucas-difference__container"
  }, [_c('div', {
    staticClass: "tab-lucas-difference__tabs"
  }, _vm._l((_vm.props), function(tab, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-lucas-difference__tab",
      class: {
        "tab-lucas-difference__tab--active": i === _vm.active
      },
      on: {
        "click": function($event) {
          _vm.showContent(i)
        },
        "mouseover": function($event) {
          _vm.showContent(i)
        }
      }
    }, [_c('Icon', {
      staticClass: "tab-lucas-difference__icon",
      attrs: {
        "name": tab.icon
      }
    })], 1)
  })), _c('div', {
    staticClass: "tab-lucas-difference__row"
  }, [_c('transition-group', {
    staticClass: "tab-lucas-difference__content-wrapper",
    attrs: {
      "name": "tab-lucas-difference__content",
      "tag": "div"
    }
  }, _vm._l((_vm.props), function(content, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i === _vm.active),
        expression: "i === active"
      }],
      key: i,
      staticClass: "tab-lucas-difference__content-container"
    }, [_c('div', {
      staticClass: "tab-lucas-difference__content-title",
      domProps: {
        "innerHTML": _vm._s(content.title)
      }
    }), _c('div', {
      staticClass: "tab-lucas-difference__content-image",
      style: ("backgroundImage: url(" + content.image + ");")
    }), _c('div', {
      staticClass: "tab-lucas-difference__content-text",
      domProps: {
        "innerHTML": _vm._s(content.body)
      }
    })])
  }))], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b31f343","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/tab/tab-lucas-difference/tab-lucas-difference.pug
// module id = 630
// module chunks = 1